// Libs
import React, { Fragment } from 'react';
// Cells
import {
	IndexCell,
	PriceCell,
	OrderCountdownCell,
	AssignedTechIdCell,
	EventIdCell,
	ZoneIdCell,
	DefaultCell,
	WarehouseNameCell,
	DefaultEditableCell,
	OrderIdCell,
	WarrantyCell,
	DocNumberCell,
	TransactionValueCell,
	InventoryTransactionValueCell,
	DeleteCell,
	WarehousePackageCell,
	StateItemCell,
	ServiceIdCell,
	ContractFrequencyIdCell,
	PaycutNameCell,
	IdCell,
	LinesQuantityCell,
	AppliedCell,
	OrdersTotalCell,
	OrdersTopayCell,
	OrdersNotpayCell,
	OrdersPreviousCell,
	OrdersPendingCell,
	OrdersPaidCell,
	AmountCell,
	BonusCell,
	SyncCell,
	StateCell,
	DecimalCell,
	TransactionSignatureActionCell,
	PaycutPaymentsActionCell,
} from './CustomCells';
import { getDefaultCell } from './defaultCellResolver';

const customCellKeyComponents = {
	index: IndexCell,
	price: PriceCell,
	orderTemporizator: OrderCountdownCell,
	assignedTechId: AssignedTechIdCell,
	eventId: EventIdCell,
	odtId: OrderIdCell,
	isWarranty: WarrantyCell,

	zoneId: ZoneIdCell,
	contractZoneId: ZoneIdCell,
	orderZoneId: ZoneIdCell,
	serviceId: ServiceIdCell,
	contractFrequencyId: ContractFrequencyIdCell,
	delete: DeleteCell,

	docNumber: DocNumberCell,
	value: TransactionValueCell,
	inventoryTransactionValue: InventoryTransactionValueCell,
	warehouse_package_id: WarehousePackageCell,
	state_name: StateItemCell,

	paycut_name: PaycutNameCell,
	paycutPaymentsAction: PaycutPaymentsActionCell,
	id: IdCell,
	lines_quantity: LinesQuantityCell,
	payment_id: AppliedCell,
	amount: AmountCell,
	charge: AmountCell,
	production_amount: AmountCell,
	production_charge: AmountCell,

	bonus: BonusCell,
	state: StateCell,
	iva: DecimalCell,

	orders_total: OrdersTotalCell,
	orders_topay: OrdersTopayCell,
	orders_notpay: OrdersNotpayCell,
	orders_previous: OrdersPreviousCell,
	orders_pending: OrdersPendingCell,
	orders_paid: OrdersPaidCell,

	paycutSync: SyncCell,
	transactionSignatureAction: TransactionSignatureActionCell,
	name: WarehouseNameCell,
	// <-- Add new custom cell key:component
};

const CellSwitcher = ({ rowData, field, readOnly }) =>
	customCellKeyComponents[field.id] ||
	getDefaultCell({
		rowData,
		field,
		readOnly,
		DefaultCell,
		DefaultEditableCell,
	});

const DataFieldSwitcher = ({
	rowIndex,
	rowData,
	field,
	selected,
	fieldActionTypes,
	profile,
	setState,
	Container = Fragment,
	stateTable,
	readOnly = false,
}) => {
	const SelectedCell = CellSwitcher({
		rowData,
		field,
		readOnly,
	});

	return (
		<Container>
			<SelectedCell
				rowIndex={rowIndex}
				rowData={rowData}
				field={field}
				selected={selected}
				fieldActionTypes={fieldActionTypes}
				profile={profile}
				setState={setState}
				stateTable={stateTable}
			/>
		</Container>
	);
};

export default DataFieldSwitcher;
